import { c as _c } from "react-compiler-runtime";
import { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { USER_ATTRIBUTES } from 'collaboration-sidebar/constants/userAttributes';
import useUserSettings from 'collaboration-sidebar/hooks/useUserSettings';
import { MODULES_WITH_REPLIES, HIDE_EMBEDDED_COMMENTS } from 'collaboration-sidebar/constants/CollaborationSidebarStateProperties';
import { getAssetKeyFromAsset } from 'collaboration-sidebar/utils/multipleAssets';
import COMMENT_TYPES from '../../../constants/CommentTypes';
import useIsCommentsDataStale from '../../../hooks/useIsCommentsDataStale';
import useHasCommentingFeature from '../../../hooks/useHasCommentingFeature';
import { useRealtimeCommentHandler } from '../../../hooks/useHasUnreadComments';
import * as commentingApi from '../../../api/CommentingV3';
export default function useSetUpEmbeddedComments(t0) {
  "use memo";

  const $ = _c(34);
  const {
    collaborationSidebarState,
    onUpdateCollaborationSidebarState
  } = t0;
  const {
    getUserSetting,
    hasLoaded: userSettingsLoaded
  } = useUserSettings();
  const hasCommentingFeature = useHasCommentingFeature();
  const assetKeyWithFetchedReplies = useRef(null);
  const [hasInitializedHideIndicators, setHasInitializedHideIndicators] = useState(false);
  const {
    isEmbeddedCommentingEnabled,
    objectId,
    objectType,
    isCommentModeActive,
    assetsLastUpdated,
    replyCounts
  } = collaborationSidebarState;
  const currentReplyCounts = useRef(replyCounts);
  let t1;
  let t2;
  if ($[0] !== replyCounts) {
    t1 = () => {
      currentReplyCounts.current = replyCounts;
    };
    t2 = [replyCounts];
    $[0] = replyCounts;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = objectType || undefined;
  let t4;
  if ($[3] !== assetsLastUpdated || $[4] !== objectId || $[5] !== t3) {
    t4 = {
      objectType: t3,
      objectId,
      assetsLastUpdated
    };
    $[3] = assetsLastUpdated;
    $[4] = objectId;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const isCommentsDataStale = useIsCommentsDataStale(t4);
  let t5;
  if ($[7] !== getUserSetting || $[8] !== userSettingsLoaded) {
    t5 = userSettingsLoaded ? getUserSetting(USER_ATTRIBUTES.HIDE_COLLABORATION_SIDEBAR_EMBEDDED_COMMENTS.key) === "true" : true;
    $[7] = getUserSetting;
    $[8] = userSettingsLoaded;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const hideIndicators = t5;
  let t6;
  if ($[10] !== hasCommentingFeature || $[11] !== hideIndicators || $[12] !== isCommentModeActive || $[13] !== isCommentsDataStale || $[14] !== isEmbeddedCommentingEnabled || $[15] !== objectId || $[16] !== objectType || $[17] !== onUpdateCollaborationSidebarState) {
    t6 = async stale => {
      const needsComments = stale || isCommentsDataStale;
      if (!hasCommentingFeature) {
        return;
      }
      const assetKey = getAssetKeyFromAsset({
        objectId: objectId || "",
        objectType: objectType || ""
      });
      if ((!hideIndicators || isCommentModeActive) && isEmbeddedCommentingEnabled && objectId && objectType && (assetKeyWithFetchedReplies.current !== assetKey || needsComments)) {
        var _response$results$fil, _response$results;
        const response = await commentingApi.fetchCommentsCached({
          objectType,
          objectId,
          refetch: needsComments
        });
        const replyComments = (_response$results$fil = (_response$results = response.results) === null || _response$results === void 0 ? void 0 : _response$results.filter(_temp)) !== null && _response$results$fil !== void 0 ? _response$results$fil : [];
        const replyCommentsMap = replyComments.reduce(_temp2, {});
        assetKeyWithFetchedReplies.current = assetKey;
        onUpdateCollaborationSidebarState({
          [MODULES_WITH_REPLIES]: replyCommentsMap
        });
        const latestReplyCounts = await commentingApi.fetchCommentRepliesCount({
          objectType,
          objectId,
          commentIds: replyComments.map(_temp3)
        });
        onUpdateCollaborationSidebarState({
          replyCounts: Object.assign({}, currentReplyCounts.current, latestReplyCounts)
        });
      }
    };
    $[10] = hasCommentingFeature;
    $[11] = hideIndicators;
    $[12] = isCommentModeActive;
    $[13] = isCommentsDataStale;
    $[14] = isEmbeddedCommentingEnabled;
    $[15] = objectId;
    $[16] = objectType;
    $[17] = onUpdateCollaborationSidebarState;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const fetchEmbeddedComments = t6;
  const t7 = objectType || undefined;
  const t8 = objectId || undefined;
  let t9;
  if ($[19] !== fetchEmbeddedComments) {
    t9 = () => void fetchEmbeddedComments(true);
    $[19] = fetchEmbeddedComments;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = {
      objectType: t7,
      objectId: t8,
      callback: t9
    };
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  useRealtimeCommentHandler(t10);
  let t11;
  let t12;
  if ($[25] !== fetchEmbeddedComments) {
    t11 = () => {
      fetchEmbeddedComments().catch(_temp4);
    };
    t12 = [fetchEmbeddedComments];
    $[25] = fetchEmbeddedComments;
    $[26] = t11;
    $[27] = t12;
  } else {
    t11 = $[26];
    t12 = $[27];
  }
  useEffect(t11, t12);
  let t13;
  let t14;
  if ($[28] !== hasInitializedHideIndicators || $[29] !== hideIndicators || $[30] !== onUpdateCollaborationSidebarState || $[31] !== userSettingsLoaded) {
    t13 = () => {
      if (!hasInitializedHideIndicators && userSettingsLoaded) {
        onUpdateCollaborationSidebarState({
          [HIDE_EMBEDDED_COMMENTS]: hideIndicators
        });
        setHasInitializedHideIndicators(true);
      }
    };
    t14 = [hasInitializedHideIndicators, hideIndicators, userSettingsLoaded, onUpdateCollaborationSidebarState];
    $[28] = hasInitializedHideIndicators;
    $[29] = hideIndicators;
    $[30] = onUpdateCollaborationSidebarState;
    $[31] = userSettingsLoaded;
    $[32] = t13;
    $[33] = t14;
  } else {
    t13 = $[32];
    t14 = $[33];
  }
  useEffect(t13, t14);
}
function _temp4(__e) {}
function _temp3(comment_1) {
  return comment_1.id;
}
function _temp2(repliesAcc, comment_0) {
  var _comment_0$parentId;
  repliesAcc[(_comment_0$parentId = comment_0.parentId) !== null && _comment_0$parentId !== void 0 ? _comment_0$parentId : ""] = comment_0;
  return repliesAcc;
}
function _temp(comment) {
  return comment.type === COMMENT_TYPES.DEEP_COMMENT && comment.parentId;
}